export * from './FireDetail';
